// DO NOT EDIT -- generated from fs/services/dx-objects/segments.proto

import { OrgToOrgDxObjectCopyResponse } from './copy.proto';
import * as accesscontrol from '../../shared/accesscontrol';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';
import * as search_settings from '../search-settings';
import * as segment from '../../api/segment';

/** To be used internally from other machines */
export namespace Segments {

  export const GetUnnamedSegmentEndpoint = "/grpc/dx_objects.Segments/GetUnnamedSegment";
  /** GetUnnamedSegment gets an unnamed segment by the client generated id */
  export function GetUnnamedSegment(sender: (req: GetUnnamedSegmentRequest, endpoint: string) => Promise<GetUnnamedSegmentResponse>, req: GetUnnamedSegmentRequest): { promise: () => Promise<GetUnnamedSegmentResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetUnnamedSegmentEndpoint),
      endpoint: GetUnnamedSegmentEndpoint
    };
  }

  export const CreateUnnamedSegmentEndpoint = "/grpc/dx_objects.Segments/CreateUnnamedSegment";
  /** CreateUnnamedSegment saves an unnamed segment */
  export function CreateUnnamedSegment(sender: (req: CreateUnnamedSegmentRequest, endpoint: string) => Promise<CreateUnnamedSegmentResponse>, req: CreateUnnamedSegmentRequest): { promise: () => Promise<CreateUnnamedSegmentResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateUnnamedSegmentEndpoint),
      endpoint: CreateUnnamedSegmentEndpoint
    };
  }
}

export namespace SegmentsPublic {

  export const GetInitialSegmentsEndpoint = "/grpc/dx_objects.SegmentsPublic/GetInitialSegments";
  /** GetInitialSegments returns the initial segments for a given seat. */
  export function GetInitialSegments(sender: (req: GetInitialSegmentsRequest, endpoint: string) => Promise<GetInitialSegmentsResponse>, req: GetInitialSegmentsRequest): { promise: () => Promise<GetInitialSegmentsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetInitialSegmentsEndpoint),
      endpoint: GetInitialSegmentsEndpoint
    };
  }

  export const GetAllSegmentsEndpoint = "/grpc/dx_objects.SegmentsPublic/GetAllSegments";
  /** GetAllSegments returns all segments for a given org with attached seat metadata. */
  export function GetAllSegments(sender: (req: GetAllSegmentsRequest, endpoint: string) => Promise<GetAllSegmentsResponse>, req: GetAllSegmentsRequest): { promise: () => Promise<GetAllSegmentsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllSegmentsEndpoint),
      endpoint: GetAllSegmentsEndpoint
    };
  }

  export const ListSegmentsEndpoint = "/grpc/dx_objects.SegmentsPublic/ListSegments";
  export function ListSegments(sender: (req: ListSegmentsRequest, endpoint: string) => Promise<ListSegmentsResponse>, req: ListSegmentsRequest): { promise: () => Promise<ListSegmentsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListSegmentsEndpoint),
      endpoint: ListSegmentsEndpoint
    };
  }

  export const BatchGetSegmentsEndpoint = "/grpc/dx_objects.SegmentsPublic/BatchGetSegments";
  export function BatchGetSegments(sender: (req: BatchGetSegmentsRequest, endpoint: string) => Promise<BatchGetSegmentsResponse>, req: BatchGetSegmentsRequest): { promise: () => Promise<BatchGetSegmentsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchGetSegmentsEndpoint),
      endpoint: BatchGetSegmentsEndpoint
    };
  }

  export const GetSegmentEndpoint = "/grpc/dx_objects.SegmentsPublic/GetSegment";
  /** Get a specific segment at the current version. */
  export function GetSegment(sender: (req: GetSegmentRequest, endpoint: string) => Promise<GetSegmentResponse>, req: GetSegmentRequest): { promise: () => Promise<GetSegmentResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSegmentEndpoint),
      endpoint: GetSegmentEndpoint
    };
  }

  export const SetSegmentEndpoint = "/grpc/dx_objects.SegmentsPublic/SetSegment";
  /** SetSegment creates or updates a segment. */
  export function SetSegment(sender: (req: SetSegmentRequest, endpoint: string) => Promise<SetSegmentResponse>, req: SetSegmentRequest): { promise: () => Promise<SetSegmentResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetSegmentEndpoint),
      endpoint: SetSegmentEndpoint
    };
  }

  export const ArchiveSegmentEndpoint = "/grpc/dx_objects.SegmentsPublic/ArchiveSegment";
  /** ArchiveSegment archives a segment. */
  export function ArchiveSegment(sender: (req: ArchiveSegmentRequest, endpoint: string) => Promise<ArchiveSegmentResponse>, req: ArchiveSegmentRequest): { promise: () => Promise<ArchiveSegmentResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveSegmentEndpoint),
      endpoint: ArchiveSegmentEndpoint
    };
  }

  export const BulkArchiveSegmentsEndpoint = "/grpc/dx_objects.SegmentsPublic/BulkArchiveSegments";
  export function BulkArchiveSegments(sender: (req: BulkArchiveSegmentsRequest, endpoint: string) => Promise<BulkArchiveSegmentsResponse>, req: BulkArchiveSegmentsRequest): { promise: () => Promise<BulkArchiveSegmentsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BulkArchiveSegmentsEndpoint),
      endpoint: BulkArchiveSegmentsEndpoint
    };
  }

  export const StarSegmentEndpoint = "/grpc/dx_objects.SegmentsPublic/StarSegment";
  /** StarSegment stars a segment for the seat. */
  export function StarSegment(sender: (req: StarSegmentRequest, endpoint: string) => Promise<{}>, req: StarSegmentRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, StarSegmentEndpoint),
      endpoint: StarSegmentEndpoint
    };
  }

  export const FollowSegmentEndpoint = "/grpc/dx_objects.SegmentsPublic/FollowSegment";
  export function FollowSegment(sender: (req: FollowSegmentRequest, endpoint: string) => Promise<{}>, req: FollowSegmentRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, FollowSegmentEndpoint),
      endpoint: FollowSegmentEndpoint
    };
  }

  export const MarkSegmentViewedEndpoint = "/grpc/dx_objects.SegmentsPublic/MarkSegmentViewed";
  /** MarkSegmentViewed updates the last viewed time for the seat. */
  export function MarkSegmentViewed(sender: (req: MarkSegmentViewedRequest, endpoint: string) => Promise<{}>, req: MarkSegmentViewedRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, MarkSegmentViewedEndpoint),
      endpoint: MarkSegmentViewedEndpoint
    };
  }

  export const CreateUnnamedSegmentEndpoint = "/grpc/dx_objects.SegmentsPublic/CreateUnnamedSegment";
  /** CreateUnnamedSegment saves an unnamed segment */
  export function CreateUnnamedSegment(sender: (req: CreateUnnamedSegmentRequest, endpoint: string) => Promise<CreateUnnamedSegmentResponse>, req: CreateUnnamedSegmentRequest): { promise: () => Promise<CreateUnnamedSegmentResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateUnnamedSegmentEndpoint),
      endpoint: CreateUnnamedSegmentEndpoint
    };
  }

  export const GetUnnamedSegmentEndpoint = "/grpc/dx_objects.SegmentsPublic/GetUnnamedSegment";
  /** GetUnnamedSegment gets an unnamed segment by the client generated id */
  export function GetUnnamedSegment(sender: (req: GetUnnamedSegmentRequest, endpoint: string) => Promise<GetUnnamedSegmentResponse>, req: GetUnnamedSegmentRequest): { promise: () => Promise<GetUnnamedSegmentResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetUnnamedSegmentEndpoint),
      endpoint: GetUnnamedSegmentEndpoint
    };
  }

  export const GetSegmentsAccessEndpoint = "/grpc/dx_objects.SegmentsPublic/GetSegmentsAccess";
  export function GetSegmentsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSegmentsAccessEndpoint),
      endpoint: GetSegmentsAccessEndpoint
    };
  }
}

/** SegmentsAdmin provides administrative operations for segments that are restricted to FullStory internal users */
export namespace SegmentsAdmin {

  export const CopySegmentsToOrgEndpoint = "/grpc/dx_objects.SegmentsAdmin/CopySegmentsToOrg";
  /**
   * CopySegmentsToOrg copies segments from one org to another
   * Only accessible to FullStory internal users
   */
  export function CopySegmentsToOrg(sender: (req: CopySegmentsToOrgRequest, endpoint: string) => Promise<OrgToOrgDxObjectCopyResponse>, req: CopySegmentsToOrgRequest): { promise: () => Promise<OrgToOrgDxObjectCopyResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CopySegmentsToOrgEndpoint),
      endpoint: CopySegmentsToOrgEndpoint
    };
  }
}

export interface GetInitialSegmentsRequest {
  orgId: string;
}

export interface GetInitialSegmentsResponse {
  everyone: SegmentDetail | null;
  starred: SegmentDetail[];
  recent: SegmentDetail[];
}

export interface GetAllSegmentsRequest {
  orgId: string;
  includeArchived: boolean;
}

export interface GetAllSegmentsResponse {
  segments: SegmentDetail[];
}

/**
 * Lists segments returning a batch of segments and pagination token.
 * A sane default limit per batch is enforced if no limit is provided.
 * The listed results can be filtered per the request.
 * The results are in descending created order.
 */
export interface ListSegmentsRequest {
  orgId: string;
  createdBetween: search_settings.ListSegmentsRequest.ListTimeRange | null;
  limit: number;
}

export interface ListSegmentsResponse {
  segments: search_settings.SegmentRecord[];
}

export interface BatchGetSegmentsRequest {
  orgId: string;
  segmentIds: string[];
}

export interface BatchGetSegmentsResponse {
  /**
   * Results are ordered in the order received from the request.
   * Not found segments will return a Result with the id supplied in the request, but a nil SegmentRecord in the response.
   * Duplicate requested identifiers will result in duplicate results (to provide 1:1 request to result indexing).
   */
  results: BatchGetSegmentsResponse.Result[];
}

export namespace BatchGetSegmentsResponse {
  export interface Result {
    id: string;
    segment: search_settings.SegmentRecord | null;
  }
}

export interface GetSegmentRequest {
  orgId: string;
  segmentId: string;
}

export interface GetSegmentResponse {
  segment: SegmentDetail | null;
}

export interface SetSegmentRequest {
  orgId: string;
  segment: search_settings.Segment | null;
  visibility: protoauditstore.Visibility;
}

export interface SetSegmentResponse {
  segment: SegmentDetail | null;
}

export interface ArchiveSegmentRequest {
  orgId: string;
  segmentId: string;
  /** if true, archive, otherwise unarchive */
  archived: boolean;
}

export interface ArchiveSegmentResponse {
  segment: SegmentDetail | null;
}

export interface BulkArchiveSegmentsRequest {
  orgId: string;
  segments: ArchiveSegmentRequest[];
}

export interface BulkArchiveSegmentsResponse {
  segments: MaybeSegmentDetail[];
}

export interface MaybeSegmentDetail {
  segmentId: string;
  failed?: boolean;
  segment?: SegmentDetail | null;
}

export namespace MaybeSegmentDetail {
  export enum failed_or_segment {
    failed = 2,
    segment = 3
  }

  export function failed_or_segment_oneof(m: MaybeSegmentDetail): { opt: failed_or_segment.failed, val: boolean } | { opt: failed_or_segment.segment, val: SegmentDetail } | null {
    if (m.failed != null) { return { opt: failed_or_segment.failed, val: m.failed } }
    if (m.segment != null) { return { opt: failed_or_segment.segment, val: m.segment } }
    return null;
  }
}

export interface StarSegmentRequest {
  orgId: string;
  segmentId: string;
  /** if true, star, otherwise unstar */
  starred: boolean;
}

export interface FollowSegmentRequest {
  orgId: string;
  segmentId: string;
  /** if true, follow, otherwise unfollow */
  followed: boolean;
}

export interface MarkSegmentViewedRequest {
  orgId: string;
  segmentId: string;
}

export interface SegmentDetail {
  segment: search_settings.SegmentRecord | null;
  /** Whether the seat has starred the funnel */
  starred: boolean;
  /** When the seat last viewed the funnel */
  lastViewed: protobuf.timestamp | null;
}

export interface CreateUnnamedSegmentRequest {
  orgId: string;
  /** unnamed_segment.id may be null, in which case the server will generate it. */
  unnamedSegment: UnnamedSegment | null;
}

export interface CreateUnnamedSegmentResponse {
  id: string;
}

export interface GetUnnamedSegmentRequest {
  orgId: string;
  id: string;
}

export interface GetUnnamedSegmentResponse {
  unnamedSegment: UnnamedSegment | null;
}

export interface UnnamedSegment {
  id: string;
  definition: segment.SegmentDefinition | null;
  disabled: UnnamedSegment.Disabled | null;
  name: string;
  /** Optional description, used mostly for preconfigured templates. */
  description: string;
}

export namespace UnnamedSegment {
  export interface Disabled {
    userProperties: UnnamedSegment.DisabledUserProperty[];
    excludeUserProperties: UnnamedSegment.DisabledUserProperty[];
    behaviors: UnnamedSegment.DisabledBehavior[];
    excludeBehaviors: UnnamedSegment.DisabledBehavior[];
  }

  export interface DisabledUserProperty {
    index: number;
    value: segment.UserProperty | null;
  }

  export interface DisabledBehavior {
    index: number;
    value: segment.Behavior | null;
  }
}

/** Request to copy segments from one org to another */
export interface CopySegmentsToOrgRequest {
  sourceOrgId: string;
  destinationOrgId: string;
  segmentIds: string[];
}
